var map = {
	"./bg.mp3": "TshJ",
	"./hero-cv-1.mp3": "Rtzf",
	"./hero-cv-2.mp3": "fN2G",
	"./hero-cv-3.mp3": "ZTLm",
	"./hero-cv-4.mp3": "1Gso",
	"./hero-cv-5.mp3": "pcny",
	"./hero-cv-6.mp3": "8ZLL",
	"./hero-cv-7.mp3": "EQht",
	"./hero-cv-8.mp3": "rD2I"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QVU9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/audio ^\.\/.*\.mp3$
// module id = QVU9
// module chunks = 13